import { rgba } from "polished";
import styled from "styled-components";
import Image from "../../../../../../../base/multimedia/image/index.js";
import { FlexMixin, FontMixin } from "../../../../../../../../styles/common/mixins/helpers.styled.js";
export const MobileBlogItemContainer = styled.div.withConfig({
    displayName: "styled__MobileBlogItemContainer",
    componentId: "sc-a798cf01-0"
})`
	flex-grow: 1;
	flex-shrink: 0;
	height: auto;
	position: relative;
	width: 100%;
	background-color: ${({ theme  })=>theme.colors.white.base};

	&.blog-item__container.blog-item__container--featured {
		flex-grow: 1;
		flex-shrink: 0;
	}
`;
export const MobileBlogItemMain = styled.div.withConfig({
    displayName: "styled__MobileBlogItemMain",
    componentId: "sc-a798cf01-1"
})`
	${FlexMixin({
    direction: 'row'
})}
	height: 100%;
	overflow: hidden;
	width: 100%;

	.blog-item__container.blog-item__container--featured & {
		${FlexMixin({
    direction: 'column'
})}
		height: 100%;
	}
`;
export const MobileBlogItemMainLink = styled.a.withConfig({
    displayName: "styled__MobileBlogItemMainLink",
    componentId: "sc-a798cf01-2"
})`
	flex-shrink: 0;
	overflow: hidden;
`;
export const MobileBlogItemDate = styled.span.withConfig({
    displayName: "styled__MobileBlogItemDate",
    componentId: "sc-a798cf01-3"
})`
	.blog-item__container.blog-item__container--featured & {
		${FlexMixin({
    direction: 'column'
})}
		right: 16px;
		position: absolute;
		text-transform: uppercase;
		top: 16px;
		z-index: 1;
		background-color: ${({ theme  })=>rgba(theme.colors.primary.light ?? theme.colors.primary.base, 0.7)};
		color: ${({ theme  })=>theme.colors.white.base};
		padding: 4px 8px;
	}
	.blog-item__container:not(.blog-item__container--featured) & {
		${FontMixin({
    size: 'medium',
    height: 'medium',
    weight: 'regular'
})};
	}
`;
export const MobileBlogItemDay = styled.span.withConfig({
    displayName: "styled__MobileBlogItemDay",
    componentId: "sc-a798cf01-4"
})`
	.blog-item__container.blog-item__container--featured & {
		${FontMixin({
    size: 'larger',
    height: 'base',
    weight: 'regular'
})}
		text-align: center;
	}
`;
export const MobileBlogItemMonth = styled.span.withConfig({
    displayName: "styled__MobileBlogItemMonth",
    componentId: "sc-a798cf01-5"
})`
	.blog-item__container.blog-item__container--featured & {
		${FontMixin({
    size: 'medium',
    height: 'base',
    weight: 'regular'
})}
		text-align: center;
	}
`;
export const MobileBlogItemImage = styled(Image).withConfig({
    displayName: "styled__MobileBlogItemImage",
    componentId: "sc-a798cf01-6"
})`
	height: auto;
	width: 100%;
`;
export const MobileBlogItemContent = styled.div.withConfig({
    displayName: "styled__MobileBlogItemContent",
    componentId: "sc-a798cf01-7"
})`
	${FlexMixin({
    direction: 'column'
})}
	width: 100%;
	flex-grow: 1;
`;
export const MobileBlogItemContentLink = styled.a.withConfig({
    displayName: "styled__MobileBlogItemContentLink",
    componentId: "sc-a798cf01-8"
})`
	.blog-item__container.blog-item__container--featured & {
		text-decoration: none;
	}
`;
export const MobileBlogItemBlock = styled.div.withConfig({
    displayName: "styled__MobileBlogItemBlock",
    componentId: "sc-a798cf01-9"
})`
	padding: 12px;
`;
export const MobileBlogItemTitle = styled.h3.withConfig({
    displayName: "styled__MobileBlogItemTitle",
    componentId: "sc-a798cf01-10"
})`
	color: ${({ theme  })=>theme.colors.grays.darker};
	${FontMixin({
    size: 'base',
    height: 'base',
    weight: 'regular'
})}
	margin: 0;

	.blog-item__container:not(.blog-item__container--featured) & {
		margin-bottom: 12px;
	}

	.blog-item__container.blog-item__container--featured & {
		${FontMixin({
    size: 'large',
    height: 'large'
})}
	}
`;

//# sourceMappingURL=styled.js.map